// frontend/src/components/SearchResults.js
import React from 'react';

const SearchResults = ({ searchRepoStructure, searchLoading, closeSearch, navigateToFolder }) => {
    return (

            <div className="mb-3 card shadow-sm mb-4">
                <div className="card-body bg-light pb-4">
                    <div className="d-inline-flex gap-2 align-items-baseline mb-4 w-100 justify-content-between">
                        <h2 className="h5">Search Results</h2>
                        <button className="btn d-flex align-items-center" type="button" onClick={closeSearch}>
                            <i className="bi bi-x-lg me-2"></i>
                        </button>
                    </div>
                    {searchRepoStructure.length > 0 && (
                        <ul className="list-group bg-light">
                            {searchRepoStructure.map((item) => (
                                <li
                                    key={item.path}
                                    className="list-group-item list-group-item-action d-flex align-items-center"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => navigateToFolder(item.path)}
                                >
                                    {item.path}
                                </li>
                            ))}
                        </ul>
                    )}
                    {searchLoading && (
                        <div className="text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    )}
                </div>
            </div>

    );
};

export default SearchResults;
